import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { ExploReportBuilderContainer } from '~/packages/explo/ui/ExploReportBuilderContainer';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <ExploReportBuilderContainer
      organizationId={user.organization.id}
      exploPlacement="lenderPortfolioTab"
    />
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsAnalyticsReportBuilderPermissions;
};
export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/analytics" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/analytics" />;
        }}
      >
        <RouteBase />
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
